export default function TrustSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-0">
          <div className="flex-1 flex flex-col justify-center py-10 lg:py-16 lg:pr-16">
            <div className="flex items-center gap-3 mb-12">
              <div className="w-2 h-2 rounded-full bg-accent-500"></div>
              <span className="text-xs font-semibold tracking-wider text-foreground-700 uppercase">
                Trusted by 50,000+ Shoppers
              </span>
            </div>

            <blockquote className="font-heading text-3xl md:text-5xl font-medium text-foreground-950 leading-[1.3] mb-10 max-w-[540px]">
              &ldquo;The Superbuy Spreadsheet completely changed how I shop online. Instead of spending hours searching, I just open the sheet and find exactly what I need.&rdquo;
            </blockquote>

            <div className="flex items-center gap-4 mb-12">
              <div>
                <p className="text-sm font-bold text-foreground-950">Superbuy Sheet Team</p>
                <div className="flex items-center gap-2 mt-1">
                  <i className="ri-verified-badge-line w-4 h-4 flex items-center justify-center text-accent-500"></i>
                  <span className="text-xs text-foreground-500">Verified Platform</span>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-stack-line w-4 h-4 flex items-center justify-center text-accent-600"></i>
                </div>
                <div>
                  <p className="text-lg font-bold text-foreground-950 font-heading">100+</p>
                  <p className="text-xs text-foreground-500">Categories</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-refresh-line w-4 h-4 flex items-center justify-center text-accent-600"></i>
                </div>
                <div>
                  <p className="text-lg font-bold text-foreground-950 font-heading">Daily</p>
                  <p className="text-xs text-foreground-500">Updates</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center text-accent-600"></i>
                </div>
                <div>
                  <p className="text-lg font-bold text-foreground-950 font-heading">QC</p>
                  <p className="text-xs text-foreground-500">Checked</p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 relative min-h-[400px] lg:min-h-[600px]">
            <img
              src="https://readdy.ai/api/search-image?query=Artistic%20black%20and%20white%20editorial%20fashion%20collage%20with%20various%20clothing%20textures%20and%20accessories%20arranged%20in%20a%20dynamic%20overlapping%20composition%2C%20high%20contrast%20monochrome%20photography%2C%20dramatic%20soft%20lighting%2C%20visible%20fabric%20grain%20leather%20grain%20and%20knit%20textures%2C%20fashion%20magazine%20editorial%20aesthetic%2C%20clean%20studio%20background%2C%20sophisticated%20avant-garde%20composition%2C%20no%20visible%20text%20or%20branding&width=800&height=900&seq=trust-collage-v2-2026&orientation=portrait"
              alt="Superbuy Spreadsheet trusted by thousands of shoppers worldwide"
              className="w-full h-full object-cover object-top rounded-2xl"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}